import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { useScrollReveal } from "../hooks/useScrollReveal";
import usePageSeo from "../hooks/usePageSeo";
import "./Services.css";

const SERVICE_IMAGES = [
  "/images/hero/Servizi - Porte Interne.jpg",
  "/images/hero/Servizi - Montaggio Arredi.jpg",
  "/images/hero/Servizi - Piccola Falegnameria.jpg",
];

const SERVICE_ICONS = [
  <svg key="1" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="18" rx="1"/><rect x="14" y="3" width="7" height="18" rx="1"/><line x1="10" y1="12" x2="14" y2="12" strokeWidth="1"/></svg>,
  <svg key="2" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.2" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="1"/><path d="M7 7V5a5 5 0 0110 0v2"/><line x1="2" y1="11" x2="22" y2="11"/></svg>,
  <svg key="3" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.2" viewBox="0 0 24 24"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3-3a1 1 0 000-1.4l-1.6-1.6a1 1 0 00-1.4 0l-3 3z"/><path d="M5 20L3 21l1-2L15 7l2 2L5 20z"/></svg>,
];

export default function Services() {
  useScrollReveal();
  const { t, lang } = useLang();

  usePageSeo({
    lang,
    path: "/services",
    title: lang === "IT"
      ? "Servizi | Porte interne, rifiniture in legno e falegnameria edile a Bari"
      : "Services | Interior doors, wood finishes and building carpentry in Bari",
    description: lang === "IT"
      ? "Scopri i servizi GDM Installations: porte interne con telai e controtelai, battiscopa, boiserie, pannellature e falegnameria edile su misura a Bari e dintorni."
      : "Discover GDM Installations services: interior doors with frames, skirting boards, boiserie, wall cladding and bespoke building carpentry in Bari and surroundings.",
    keywords: lang === "IT"
      ? "porte interne Bari, boiserie Bari, battiscopa su misura Bari, falegnameria edile Bari, scale legno Bari, ringhiere legno Bari, pannellature Bari"
      : "interior doors Bari, boiserie Bari, skirting boards Bari, building carpentry Bari, wooden staircases Bari, wood railings Bari, wall cladding Bari",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: lang === "IT" ? "Falegnameria edile e rifiniture in legno" : "Building carpentry and wood finishes",
      provider: {
        "@type": "LocalBusiness",
        name: "GDM Installations",
        url: "https://gdminstallations.it/",
      },
      areaServed: "Bari e dintorni",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: lang === "IT" ? "Servizi GDM Installations" : "GDM Installations Services",
        itemListElement: t.services.items.map((item) => ({
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: item.title,
            description: item.description,
          },
        })),
      },
    },
  });

  return (
    <div className="services-page">
      <div className="page-hero-mini">
        <h1 className="page-hero-title fade-in">{t.services.title}</h1>
        <div className="gold-line" />
        <p className="page-hero-sub fade-in fade-in-delay-1">{t.services.subtitle}</p>
      </div>

      <section className="services-section section">
        <div className="section-inner">
          <div className="services-list">
            {t.services.items.map((svc, i) => (
              <div key={i} className={`service-item ${i % 2 !== 0 ? "reversed" : ""} ${i % 2 === 0 ? "reveal-left" : "reveal-right"} fade-in-delay-${i + 1}`}>
                <div className="service-img-wrap">
                  <img src={SERVICE_IMAGES[i]} alt={svc.title} />
                </div>
                <div className="service-content">
                  <div className="service-icon">{SERVICE_ICONS[i]}</div>
                  <h2 className="service-title">{svc.title}</h2>
                  <div className="gold-line-left" />
                  <p className="service-desc">{svc.description}</p>
                  {svc.details && (
                    <ul className="service-details">
                      {svc.details.map((d, j) => (
                        <li key={j}>{d}</li>
                      ))}
                    </ul>
                  )}
                  <Link to="/contact" className="btn-gold" style={{ display: "inline-block", marginTop: "1.5rem" }}>{svc.cta}</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="services-cta-banner section">
        <div className="section-inner" style={{ textAlign: "center" }}>
          <h2 className="section-title fade-in">{t.project.title}</h2>
          <div className="gold-line" />
          <p className="section-subtitle fade-in fade-in-delay-1">{t.project.subtitle}</p>
          <Link to="/contact" className="btn-outline fade-in fade-in-delay-2" style={{ marginTop: "2rem", display: "inline-block" }}>
            {t.contact.requestConsultation}
          </Link>
        </div>
      </section>
    </div>
  );
}
